export default "__VITE_PUBLIC_ASSET__ef2f5931__"